// The three identifiers the invoice tables render together in their "Order" column. Searching
// fewer than all three leaves a row unfindable by something it visibly displays.
const ORDER_IDENTIFIER_FIELDS = ['order_number', 'po_number', 'reference_id'];

export const orderIdentifierMatch = (searchTerm) => ({
    _or: ORDER_IDENTIFIER_FIELDS.map((field) => ({ [field]: { _ilike: `%${searchTerm}%` } })),
});

// Builds the searchTerm predicate for a carrier_invoices query. `legs` names the order
// relationships to search across: receivables hold theirs on shipper_orders alone, while a
// payable spreads them over the carrier and contractor buckets.
export const invoiceSearchWhere = (searchTerm, legs) => {
    const orderMatch = orderIdentifierMatch(searchTerm);
    const conditions = legs.map((leg) => ({ [leg]: orderMatch }));

    // invoice_number is an integer column — _ilike against it errors rather than just missing,
    // so it only joins the search when the term parses as one.
    const parsed = parseInt(searchTerm, 10);
    if (!isNaN(parsed) && Number.isInteger(parsed)) {
        conditions.push({ invoice_number: { _eq: parsed } });
    }

    return { _or: conditions };
};
